import React, { Component } from 'react';
import { Tooltip } from '@blueprintjs/core';
import ItemInfo from './ItemInfo';

export default class Inventory extends Component {
  constructor() {
    super();

    this.state = { ActivePage: 'Set' };
  }

  render() {
    return (
      <div>
        {this.state.ActivePage === 'Set' ? (
          <div className="Inventory bg-equipment pull-left">
            <div className="ItemSlots 6 left weapon">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/weapon/blade_10.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 7 right shield">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/shield/shield_10.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 0 left head">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_ha.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 2 right shoulder">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_sa.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 1 left chest">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_ba.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 3 right hands">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_aa.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 4 left legs">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_la.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 5 right foot">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/man_item/clothes_09_fa.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 9 left earring">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/acc/earring_09.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 10 right necklace">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/acc/necklace_09.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 11 left lring">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/acc/ring_10.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="ItemSlots 12 right rring">
              <Tooltip
                content={<ItemInfo />}
                position="right"
                portalClassName="PortalFree"
              >
                <div className="ItemSlot">
                  <div
                    className="image"
                    style={{
                      background:
                        'url("http://www.sawsro.com/media/images/equipment/item/china/acc/ring_10.PNG") no-repeat',
                    }}
                  >
                    <span className="qinfo"></span>
                    <span className="plus"></span>
                  </div>
                </div>
              </Tooltip>
            </div>
            <button
              className="btn-equip-avatar"
              onClick={() => {
                this.setState({ ...this.state, ActivePage: 'Avatar' });
              }}
            ></button>
            <div className="equip-suit-slot">
              <div className="ItemSlot">
                <div></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="Inventory bg-equipment-avatar pull-left">
            <div className="avatar-margin">
              <div className="ItemSlots 4 left spec">
                <Tooltip
                  content={<ItemInfo />}
                  position="right"
                  portalClassName="PortalFree"
                >
                  <div className="ItemSlot">
                    <div
                      className="image"
                      style={{
                        background:
                          'url("http://www.sawsro.com/media/images/equipment/item/avatar/mall_avatar_m_nasrun.PNG") no-repeat',
                      }}
                    ></div>
                  </div>
                </Tooltip>
              </div>

              <div className="ItemSlots 1 right flag">
                <Tooltip
                  content={<ItemInfo />}
                  position="right"
                  portalClassName="PortalFree"
                >
                  <div className="ItemSlot">
                    <div
                      className="image"
                      style={{
                        background:
                          'url("http://www.sawsro.com/media/images/equipment/item/avatar/e051021_whitetiger_bunting_m.PNG") no-repeat',
                      }}
                    ></div>
                  </div>
                </Tooltip>
              </div>

              <div className="ItemSlots 2 left dress">
                <Tooltip
                  content={<ItemInfo />}
                  position="right"
                  portalClassName="PortalFree"
                >
                  <div className="ItemSlot">
                    <div
                      className="image"
                      style={{
                        background:
                          'url("http://www.sawsro.com/media/images/equipment/item/avatar/mall_avatar_m_arabia_hat.PNG") no-repeat',
                      }}
                    ></div>
                  </div>
                </Tooltip>
              </div>

              <div className="ItemSlots 0 left hat">
                <Tooltip
                  content={<ItemInfo />}
                  position="right"
                  portalClassName="PortalFree"
                >
                  <div className="ItemSlot">
                    <div
                      className="image"
                      style={{
                        background:
                          'url("http://www.sawsro.com/media/images/equipment/item/avatar/mall_avatar_m_angel_wing_dress.PNG") no-repeat',
                      }}
                    ></div>
                  </div>
                </Tooltip>
              </div>

              <div className="ItemSlots 3 right attach">
                <div className="ItemSlot">
                  <div className="image"></div>
                </div>
              </div>

              <button
                className="btn-equip-set"
                onClick={() => {
                  this.setState({ ...this.state, ActivePage: 'Set' });
                }}
              ></button>
              <div className="equip-suit-slot">
                <div className="ItemSlot">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
